import { render, staticRenderFns } from "./ProtoScoreV2.vue?vue&type=template&id=671c822f&scoped=true"
import script from "./ProtoScoreV2.vue?vue&type=script&lang=js"
export * from "./ProtoScoreV2.vue?vue&type=script&lang=js"
import style0 from "./ProtoScoreV2.vue?vue&type=style&index=0&id=671c822f&prod&lang=scss"
import style1 from "./ProtoScoreV2.vue?vue&type=style&index=1&id=671c822f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671c822f",
  null
  
)

export default component.exports